<template>
<div id="content">
	<div class="inner center">
		<h2>はじめに</h2>
		<!-- 内容 -->
		<div class="center">
			<p>下記をお読みになってから、ご登録ください。</p>
			<div class="scroll-content">{{message}}</div>
			<div class="point_text btn_download" style="margin: 5px auto;">
				<a href="/pdf/Doui.pdf" download="Doui.pdf" target="_blank">
				<span><fa icon="download" class="icon far fa-angle-double-down fa-fw" />同意書ダウンロード</span></a>
			</div>
		</div>
	</div>
	<div class="center">
		<router-link to="/"><button class="btn_cancel">戻る</button></router-link>
		<router-link to="/katudo-touroku/step1"><button class="btn_on">同意する</button></router-link>
	</div>
</div>
</template>

<script>
import { inject } from 'vue';
import axios from 'axios';
export default {
	name: 'KatsudoTouroku1',
	data() {
		return {
			message: "",
		};
	},
	setup(){
		const { katudoReset } = inject('ktouroku');
		return {
			katudoReset,
		};
	},
	async created() {
		let res = await axios.get('/api/common/message');
		// console.log(res)
		this.message = res.data;

		this.katudoReset();
	},
}
</script>
